import React from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
} from '@mui/material';

function About() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 }, mt: { xs: '56px', sm: '64px' } }}>
      <Paper 
        elevation={0}
        sx={{ 
          p: { xs: 3, md: 6 },
          backgroundColor: '#f8f8f8',
          borderRadius: 2
        }}
      >
        {/* Logo Alanı */}
        <Box 
          sx={{ 
            display: 'flex',
            justifyContent: 'center',
            mb: 4
          }}
        >
          <img
            src="/images/logo.jpg"
            alt="Kayla Butik Logo"
            style={{
              height: '120px',
              objectFit: 'contain'
            }}
          />
        </Box>

        {/* Başlık */}
        <Typography 
          variant="h4" 
          component="h1" 
          align="center"
          sx={{ 
            mb: 4,
            fontWeight: 600,
            color: 'primary.main'
          }}
        >
          Hakkımızda - Kayla Butik
        </Typography>

        <Divider sx={{ mb: 4 }} />

        {/* İlk Paragraf */}
        <Typography 
          variant="body1" 
          paragraph
          sx={{ 
            mb: 3,
            lineHeight: 1.8,
            fontSize: { xs: '1rem', md: '1.1rem' }
          }}
        >
          Giyinmek ve giydirmek bir sanattır, biz bu sanatın tutkuyla peşindeyiz. 
          2019 yılında İstanbul Şişli'de bir butik olarak çıktığımız bu keyifli yolculukta, 
          siz değerli müşterilerimizin desteğiyle büyüdük ve şimdi e-ticaret dünyasına 
          adım atmanın mutluluğunu yaşıyoruz.
        </Typography>

        {/* İkinci Paragraf */}
        <Typography 
          variant="body1" 
          paragraph
          sx={{ 
            mb: 4,
            lineHeight: 1.8,
            fontSize: { xs: '1rem', md: '1.1rem' }
          }}
        >
          Sevdiğimiz işi yaparken, etrafımıza mutluluk yaymak en büyük hedefimiz. 
          Sunduğumuz her ürünle sizlere şıklık, zarafeti sunmayı amaçlıyoruz. 
          Kayla Butik olarak, modayı sizinle buluşturmak için buradayız.
        </Typography>

        {/* İmza */}
        <Box sx={{ textAlign: 'right', mt: 6 }}>
          <Typography 
            variant="body1"
            sx={{ 
              fontStyle: 'italic',
              color: 'text.secondary'
            }}
          >
            Sevgilerimizle,
          </Typography>
          <Typography 
            variant="h6"
            sx={{ 
              fontWeight: 600,
              color: 'primary.main'
            }}
          >
            Kayla Butik Ekibi
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default About; 